import React from 'react';
import { ButtonBase, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { EditOrderDialogIntent } from './footer/EditOrderDialogFooter';

export const TOGGLE_GROUP_SX = {
  gap: 1,
  '& .MuiToggleButton-root': { textTransform: 'none', flex: 1 },
  '& .MuiToggleButtonGroup-grouped': {
    borderRadius: '6px',
    border: '1px solid',
    borderColor: 'mb.control',
    '&:not(:first-of-type)': { marginLeft: 0, borderLeft: '1px solid', borderLeftColor: 'inherit' },
  },
};

const INTENT_TABS = [
  { intent: EditOrderDialogIntent.CreateOrder, labelKey: 'calendar.edit_order.create_order' },
  { intent: EditOrderDialogIntent.RedeemPass, labelKey: 'passes.redeem_pass' },
];

type IntentToggleProps = {
  editOrderDialogIntent: EditOrderDialogIntent;
  onToggleIntent?: (intent: EditOrderDialogIntent) => void;
};

// One-time order / pass redemption switch, drawn as tabs in the same style as the create wizard's stepper.
export const IntentToggle = ({ editOrderDialogIntent, onToggleIntent }: IntentToggleProps) => {
  const { t } = useTranslation();
  return (
    <Grid
      container
      wrap="nowrap"
      role="tablist"
      sx={{
        flexShrink: 0,
        width: 'auto',
        mx: { xs: '-12px', md: '-24px' },
        mb: 1.5,
        borderBottom: '1px solid',
        borderColor: 'mb.lineSoft',
      }}>
      {INTENT_TABS.map(({ intent, labelKey }) => {
        const isSelected = intent === editOrderDialogIntent;
        return (
          <ButtonBase
            key={intent}
            role="tab"
            aria-selected={isSelected}
            onClick={() => !isSelected && onToggleIntent?.(intent)}
            sx={{
              flex: 1,
              minWidth: 0,
              minHeight: 48,
              px: 1,
              bgcolor: isSelected ? 'mb.ground' : undefined,
              boxShadow: (theme) => (isSelected ? `inset 0 -3px 0 ${theme.palette.primary.main}` : undefined),
            }}>
            <Typography
              noWrap
              sx={{
                fontSize: 15,
                fontWeight: isSelected ? 700 : 500,
                color: isSelected ? 'primary.main' : 'text.secondary',
              }}>
              {t(labelKey)}
            </Typography>
          </ButtonBase>
        );
      })}
    </Grid>
  );
};
